import { adminLogout } from '../../../api/adminApi';
import { t } from './context';
import { showSubscriptionsScreen } from './subscriptions';
import { showHourlyPaymentScreen } from './hourlyPayment';
import { showWorkingHoursScreen } from './workingHours';
import { showSellSubscriptionScreen } from './sellSubscription';
import { showRemainingHoursScreen } from './remainingHours';
import { showBookingsScreen } from './bookingsCalendar';
import { showBookingHistoryScreen } from './bookingHistory';
import { showClientsScreen } from './clients';
export function showDashboardScreen(ctx) {
    ctx.screen.innerHTML = '';
    const header = document.createElement('div');
    header.className = 'admin__header';
    const title = document.createElement('h1');
    title.className = 'section-title admin__title';
    title.textContent = t('admin.dashboard.title');
    const logoutButton = document.createElement('button');
    logoutButton.type = 'button';
    logoutButton.className = 'admin__logout';
    logoutButton.textContent = t('admin.dashboard.logout');
    logoutButton.addEventListener('click', () => {
        adminLogout()
            .catch((err) => console.error('Failed to log out:', err))
            .finally(() => ctx.showLogin());
    });
    header.append(title, logoutButton);
    const menu = document.createElement('div');
    menu.className = 'admin__menu';
    const menuItems = [
        { label: t('admin.dashboard.menu.subscriptions'), active: true, action: () => showSubscriptionsScreen(ctx) },
        { label: t('admin.dashboard.menu.hourlyPayment'), active: true, action: () => showHourlyPaymentScreen(ctx) },
        { label: t('admin.dashboard.menu.workingHours'), active: true, action: () => showWorkingHoursScreen(ctx) },
        { label: t('admin.dashboard.menu.sellSubscription'), active: true, action: () => showSellSubscriptionScreen(ctx) },
        { label: t('admin.dashboard.menu.remainingHours'), active: true, action: () => showRemainingHoursScreen(ctx) },
        { label: t('admin.dashboard.menu.bookings'), active: true, action: () => showBookingsScreen(ctx) },
        { label: t('admin.dashboard.menu.bookingHistory'), active: true, action: () => showBookingHistoryScreen(ctx) },
        { label: t('admin.dashboard.menu.clients'), active: true, action: () => showClientsScreen(ctx) },
    ];
    for (const item of menuItems) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = item.active ? 'admin__menu-item' : 'admin__menu-item admin__menu-item--disabled';
        button.textContent = item.label;
        button.disabled = !item.active;
        if (item.active && item.action) {
            button.addEventListener('click', item.action);
        }
        menu.appendChild(button);
    }
    ctx.screen.append(header, menu);
}
